import Vue from 'vue';
import VueRouter from 'vue-router';

import Projects from '@/components/Projects'
import Project from '@/components/Project'
import About from '@/components/About';
import NotFound from '@/components/NotFound';

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/about',
      component: About
    },
    {
      path: '/:category?',
      component: Projects
    },
    {
      path: '/project/:project',
      component: Project
    },
    {
      path: '*',
      component: NotFound
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js